<template>
  <a-dims-search-bar
    placeholder="Buscar viaje"
    hide-search
    @search="fetchTrips({ search: $event }, false)">

    <router-link
      active-class="border-b-2 border-primary text-primary"
      to="/trips"
      class="inline-block py-4">
      Mis viajes
    </router-link>
    <template #trips>
      <button class="bg-green_chat rounded-md py-2 transition-all px-4 active:bg-green-400" @click="showCreateTrip = !showCreateTrip">
        <span class="flex items-center text-white">
          <span>+</span>
          <span class="ml-4">Nuevo viaje</span>
        </span>
      </button>
    </template>

  </a-dims-search-bar>
  <!--  <div class="mt-24">-->
  <!--    <input type="text" placeholder="Search" />-->
  <!--  </div>-->
  <div class="flex py-20">
    <a-list
      class="flex flex-col gap-4"
      :source="pagination.data"
      :loading="loading"
      :should-emit-bottom-reached="pagination.next_page_url !== null"
      @bottom-reached="fetchTrips({ page: pagination.next_page_url ? pagination.current_page + 1 : pagination.current_page }, true)">
      <template #default="{ item }">
        <card :item="item" @update-trip="handleTrip($event)" @delete-trip="handleDeleteTrip($event)" />
      </template>

      <template #empty>
        <div class="flex flex-col rounded-md" style="box-shadow: 0 0 3px #cecece; padding: 30px 0">
          <p class="text-onboarding_light_gray">No tienes ningún plan de viaje</p>
          <p class="text-green_chat cursor-pointer mt-3" @click="showCreateTrip = !showCreateTrip">+ Crear Viaje</p>
        </div>
      </template>
    </a-list>
    <div class="h-24"></div>
  </div>

  <a-alert
    :show="showCreateTrip"
    :cancelClass="'border items-center text-base rounded-md p-2 p-4 sm:text-base'"
    :confirmClass="'trip-confirm-button border-primary ml-2 transition-all border rounded-md p-2 p-4 text-primary'"
    :cancelText="'Cancelar'"
    :disabledConfirm="!form.country_iso || !form.state || !form.start_date || !form.end_date || loadingCreateTrip"
    @confirm="createTrip()"
    @cancel="showCreateTrip = false;selectedTrip = null">
    <h1 class="text-lg font-semibold text-black text-center">Crear Nuevo Viaje</h1>
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-2">
        <label for="country" class="text-black">País</label>
        <select id="country" class="border p-1 rounded p-2 font-bold" v-model="form.country_iso" @change="fetchStates">
          <option disabled selected>Seleccione una opción</option>
          <option v-for="country in filteredCountries" :key="country.value" :value="country.value" class="capitalize">{{ country.text }}</option>
        </select>
      </div>

      <div class="flex flex-col gap-2">
        <label for="country" class="text-black">Ciudad/Estado</label>
        <select id="country" class="border p-1 rounded p-2 font-bold capitalize transition-all disabled:bg-gray-300" v-model="form.state" :disabled="!form.country_iso || loadingStates">
          <option v-for="state in states" :key="state" :value="state">{{ state }}</option>
        </select>
      </div>

      <div class="flex items-center gap-2">
        <div class="flex-1">
          <h4 class="text-black cursor-default">Fecha de inicio</h4>
          <div class="flex flex-row gap-1 border items-center rounded-md text-left px-4" :style="!form.state ? { background: '#d4d4d8' } : {}">
            <i class="icon-calendar" />
            <Calendar
              class="trip-calendar w-full"
              v-model="form.start_date"
              date-format="dd/mm/yy"
              :disabled="!form.state"
              :min-date="minDate()"
              :showTime="false"
              :touchUI="true"
              :manualInput="false"
            />
          </div>
        </div>
        <div class="flex-1">
          <h4 class="text-black cursor-default">Fecha de fin</h4>
          <div class="flex flex-row gap-1 border items-center rounded-md text-left px-4" :style="!form.state ? { background: '#d4d4d8' } : {}">
            <i class="icon-calendar" />
            <Calendar
              class="trip-calendar w-full"
              v-model="form.end_date"
              date-format="dd/mm/yy"
              :disabled="!form.state"
              :min-date="minDate()"
              :showTime="false"
              :touchUI="true"
              :manualInput="false"
            />
          </div>
        </div>
      </div>
    </div>
    <template #confirm>
      <a-loader color="text-primary" class="h-6 w-6" v-if="loadingCreateTrip" />
      <template v-else>
        Aceptar
      </template>
    </template>
  </a-alert>
  <a-alert :show="error" hide-cancel @confirm="error = false">
    <div class="flex space-x-4 items-start">
      <i class="icon-close p-4 text-xl bg-red-500 rounded-full text-white shadow-lg" />
      <div class="flex flex-col">
        <h1 class="text-black text-lg">¡ha ocurrido un error!</h1>
        <h1 class="text-base mt-2">No se ha podido crear el viaje, intente nuevamente</h1>
      </div>
    </div>
  </a-alert>
  <a-alert
    :show="showDeleteTripModal"
    :loader="loadingDelete"
    :loading="loadingDelete"
    :confirm-text="'Aceptar'"
    :cancel-text="'Cancelar'"
    :title="'Eliminar'"
    :loaderStyle="'h-6 w-6 text-gray-300'"
    @confirm="deleteTrip"
    @cancel="showDeleteTripModal = false"
  >
    <div class="flex">
      <p class="inline-block align-middle text-red">¿Seguro que desea eliminar este viaje?</p>
    </div>
  </a-alert>
</template>

<script>
import { computed, inject, onMounted, reactive, ref, watch } from 'vue'
import { useRepository } from '@/hooks'
import Card from './card'
import countries from '@/assets/countries/countries'
import Calendar from 'primevue/calendar'

export default {
  name: 'trips',
  components: { Card, Calendar },
  setup () {
    const query = reactive({ limit: 15 })
    const tripsRepository = useRepository(({ trips }) => trips)
    const restRepository = useRepository(({ restaurants }) => restaurants)
    const $filters = inject('$filters', {})
    const loading = ref(true)
    const loadingCountries = ref(false)
    const loadingStates = ref(false)
    const loadingCreateTrip = ref(false)
    const loadingDelete = ref(false)
    const results = ref({ data: [], total: 0, next_page_url: null, current_page: 1 })
    const showCreateTrip = ref(false)
    const showDeleteTripModal = ref(false)
    const form = reactive({
      country_iso: '',
      state: '',
      start_date: '',
      end_date: ''
    })
    const filteredCountries = ref([])
    const states = ref([])
    const error = ref(false)
    const selectedTrip = ref(null)

    const minDate = () => {
      const today = new Date()
      const month = today.getMonth()
      const year = today.getFullYear()
      const minimalDate = ref(new Date())
      const prevMonth = (month === 0) ? 11 : month - 1
      const prevYear = (prevMonth === 11) ? year - 1 : year

      minimalDate.value.setMonth(month)
      minimalDate.value.setFullYear(prevYear)

      return new Date(minimalDate.value)
    }

    const fetchTrips = (segment = {}, appending = false) => {
      // this.query.value = { ...this.query.value, segment }
      const queryValue = { ...query, ...segment }

      // if (!appending) {
      //   results.value = { data: [], total: 0, next_page_url: null, current_page: 1 }
      // }

      loading.value = true
      tripsRepository.index(queryValue)
        .then(({ data }) => {
          if (appending) {
            results.value = {
              ...results.value,
              ...data,
              data: results.value.data.concat(data.data)
            }
          } else {
            results.value = data
          }
        })
        .finally(() => {
          loading.value = false
        })
    }
    const fetchCountries = () => {
      loadingCountries.value = true
      restRepository.countries()
        .then(({ data }) => {
          const values = data.map((val) => val.toUpperCase())
          if (values.length > 0) {
            filteredCountries.value = countries.filter(($0) => values.includes($0.value))
          } else {
            filteredCountries.value = []
          }
        })
        .finally(() => {
          loadingCountries.value = false
        })
    }

    const fetchStates = () => {
      loadingStates.value = true
      form.state = ''
      return restRepository.states({ country_iso: form.country_iso })
        .then(({ data }) => {
          if (data.length > 0) {
            states.value = data
          } else {
            states.value = []
          }
        })
        .finally(() => {
          loadingStates.value = false
        })
    }

    const createTrip = () => {
      loadingCreateTrip.value = true
      const start = $filters.moment(form.start_date, 'YYYY-MM-DD', true)
      const end = $filters.moment(form.end_date, 'YYYY-MM-DD', true)

      if (selectedTrip.value) {
        tripsRepository.update(selectedTrip.value.id, { ...form, start_date: start, end_date: end })
          .then(() => {
            fetchTrips(query, false)
          })
          .catch(() => {
            error.value = true
          })
          .finally(() => {
            loadingCreateTrip.value = false
            showCreateTrip.value = false
          })
      } else {
        tripsRepository.store({ ...form, start_date: start, end_date: end })
          .then(() => {
            fetchTrips(query, false)
          })
          .catch(() => {
            error.value = true
          })
          .finally(() => {
            loadingCreateTrip.value = false
            showCreateTrip.value = false
          })
      }
    }

    const pagination = computed(() => ({
      ...results.value
    }))

    const handleTrip = (trip) => {
      selectedTrip.value = trip
      form.country_iso = trip.country_iso.toUpperCase()
      fetchStates()
        .then(() => {
          showCreateTrip.value = true
        })
      form.state = trip.state
      form.start_date = $filters.moment(trip.start_date, 'YYYY-MM-DD', true)
      form.end_date = $filters.moment(trip.end_date, 'YYYY-MM-DD', true)
      console.log(form)
    }

    const handleDeleteTrip = (trip) => {
      selectedTrip.value = trip
      showDeleteTripModal.value = true
    }

    const deleteTrip = () => {
      loadingDelete.value = true
      tripsRepository.delete(selectedTrip.value.id)
        .then(({ data }) => {
          fetchTrips(query, false)
          showDeleteTripModal.value = false
        })
        .finally(() => {
          loadingDelete.value = false
        })
    }

    watch(showCreateTrip, (value) => {
      if (value && !selectedTrip.value) {
        form.country_iso = ''
        form.state = ''
        form.start_date = ''
        form.end_date = ''
      }
    })

    onMounted(() => {
      fetchTrips(query, true)
      fetchCountries()
    })

    return {
      loading,
      loadingCountries,
      loadingStates,
      loadingCreateTrip,
      loadingDelete,
      error,
      results,
      pagination,
      showCreateTrip,
      showDeleteTripModal,
      form,
      filteredCountries,
      states,
      selectedTrip,
      minDate,
      fetchTrips,
      fetchStates,
      createTrip,
      handleTrip,
      handleDeleteTrip,
      deleteTrip
    }
  }
}
</script>

<style>
.trip-calendar{
  .p-inputtext{
    background: #ffffff00 !important;
    border-radius: 5px !important;
    height: 40px !important;
    border: none !important;
    padding: 0 !important;
    text-align: left !important;
  }
  .p-inputtext:enabled:focus {
    outline: none !important;
  }
}
.trip-confirm-button:disabled {
  border: 1px solid #dddddd !important;
}
</style>
